import * as React from "react";
import { type ReactNode } from 'react';

import styled from 'styled-components';
import { getColor, getFontSize} from '@process-advisor/process-miner/shared/theme';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { apiProvider } from "@process-advisor/process-miner/api/apiProvider";
import { Event } from '@process-advisor/process-miner/api/events';1

import { Statistics } from '@process-advisor/process-miner/model/statistics/statistics';
import { EventDetail } from '@process-advisor/process-miner/model/events/eventDetail';
import { TaskDetail } from '@process-advisor/process-miner/model/tasks/taskDetail';


import { Typography } from '@mui/material';
import Tabs, { Tab, TabList, TabPanel} from '@atlaskit/tabs';
import { css } from '@emotion/react';

const Wrapper = styled.div`
    display: grid;
    width: 100%;
    height: 100%;
    background-color: ${getColor('lightestGray')};
    padding-bottom: 10px;
    padding-top: 30px;
    padding-left: 30px;
    padding-right: 30px;
    grid-template-rows: auto;
    grid-template-columns: 1fr;
    grid-column-gap: 25px;
    column-gap: 25px;
    .css-46bh2p-MuiCardContent-root {
        padding-left: 20px;
        padding-right: 2-0px;
    }
`;

const WrapperCol1 = styled.div`
    display: grid;
    grid-row: 1 ;
    grid-column: 1 ;
`;

const TabWrapper = styled.div`
    display: grid;
    width: 100%;
    height: 100%;
    padding-left: 10px;
    grid-template-rows: auto;
`;

const TabHeaderWrapper = styled.div`
    display: grid;
    grid-row: 1 ;
    grid-column: 1 ;
`;

const TabGridWrapper = styled.div`
    display: grid;
    grid-row: 2 ;
    grid-column: 1 ;
`;

const HeaderGrid = styled.div`
    display: grid;
    grid-template-rows: auto;
    grid-template-columns: 1fr 250px;
    padding-bottom: 5px;
    padding-top: 10px;
`;

const HeaderGridText = styled.div`
    display: grid;
    grid-row: 1 ;
    grid-column: 1 ;
    justify-content: left;
`;

const panelStyles = css({
	display: 'flex',
	padding: '32px',
	alignItems: 'center',
	justifyContent: 'center',
	flexDirection: 'column',
	flexGrow: 1,
	backgroundColor: '',
	borderRadius: '3px',
	color: '',
	font: '',
	marginBlockEnd: '8px',
	marginBlockStart: '16px',
});

export const Panel = ({ children, testId }: { children: ReactNode; testId?: string }) => (
	<div css={panelStyles} data-testid={testId}>
		{children}
	</div>
);  

export const Model: React.FC = () => {

    React.useEffect(() => {
        const listener = () => {
            //updateContent()
        };
        listener();

        apiProvider.on(Event.setActionBar_Model, listener);

        return () => {
            apiProvider.off(Event.setActionBar_Model, listener);
        };
    }, []);


    return (
        <div>
        <Wrapper>
            <WrapperCol1>
            <Card  >
                    <CardContent>
                        <Tabs id="custom-tabs">
	    		            <TabList>
		        	    	    <Tab>Status</Tab>
		    	    	        <Tab>{apiProvider.getEntityUpper() + 's'}</Tab>
		    	    	        <Tab>Events</Tab>
    		    	        </TabList>
                            <TabPanel>
                                <TabWrapper>
                                    <TabHeaderWrapper>
                                        <HeaderGrid>
                                            <HeaderGridText>
                                            <Typography sx={{color: '#0B66E4', fontWeight: 'bold', fontSize: 16}}                                            >
                                                Status
                                            </Typography>
                                            </HeaderGridText>
                                        </HeaderGrid>
                                    </TabHeaderWrapper>
                                    <TabGridWrapper>
                                        <Statistics/>
                                    </TabGridWrapper>
                                </TabWrapper>
                            </TabPanel>
                            <TabPanel>
                                <TabWrapper>
                                    <TabHeaderWrapper>
                                        <HeaderGrid>
                                            <HeaderGridText>
                                            <Typography sx={{color: '#0B66E4', fontWeight: 'bold', fontSize: 16}}                                            >
                                                {apiProvider.getEntityUpper() + 's'}
                                            </Typography>
                                            </HeaderGridText>
                                        </HeaderGrid>
                                    </TabHeaderWrapper>
                                    <TabGridWrapper>
                                        <TaskDetail/>
                                    </TabGridWrapper>
                                </TabWrapper>
                            </TabPanel>
                            <TabPanel>
                                <TabWrapper>
                                    <TabHeaderWrapper>
                                        <HeaderGrid>
                                            <HeaderGridText>
                                            <Typography sx={{color: '#0B66E4', fontWeight: 'bold', fontSize: 16}}                                            >
                                                Events
                                            </Typography>
                                            </HeaderGridText>
                                        </HeaderGrid>
                                    </TabHeaderWrapper>
                                    <TabGridWrapper>
                                        <EventDetail/>
                                    </TabGridWrapper>
                                </TabWrapper>
                            </TabPanel>
                        </Tabs>
                    </CardContent>
                </Card>
            </WrapperCol1>
        </Wrapper>
        </div>
    );
};

